import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// Obtener la URL base de la API de las variables de entorno
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const ChatTest = () => {
  const [connected, setConnected] = useState(false);
  const [sender, setSender] = useState('');
  const [receiver, setReceiver] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const socketRef = useRef(null);
  
  // Conectar al socket cuando el componente se monta
  useEffect(() => {
    console.log("Conectando a Socket.io en:", API_URL);
    socketRef.current = io(API_URL);
    
    socketRef.current.on('connect', () => {
      console.log('Conectado al servidor WebSocket - ID:', socketRef.current.id);
      setConnected(true);
    });
    
    // Escuchar tanto 'chat message' como 'message' para mayor compatibilidad
    socketRef.current.on('chat message', (data) => {
      console.log('Mensaje recibido (chat message):', data);
      setMessages(prev => [...prev, data]);
    });
    
    socketRef.current.on('message', (data) => {
      console.log('Mensaje recibido (message):', data);
      setMessages(prev => [...prev, data]);
    });
    
    // Manejar errores de conexión
    socketRef.current.on('connect_error', (error) => {
      console.error('Error de conexión Socket.io:', error);
    });
    
    socketRef.current.on('disconnect', (reason) => {
      console.log('Desconectado del servidor WebSocket:', reason);
      setConnected(false);
    });
    
    return () => {
      if (socketRef.current) {
        console.log('Limpiando conexión Socket.io');
        socketRef.current.disconnect();
      }
    };
  }, []);
  
  const handleSendMessage = (e) => {
    e.preventDefault();
    
    if (!sender || !receiver || !message) {
      alert("Completa todos los campos antes de enviar.");
      return;
    }
    
    const data = { 
      sender, 
      receiver, 
      message,
      timestamp: new Date().toISOString()
    };
    
    console.log('Enviando mensaje:', data);
    
    // Añadir el mensaje a la lista local inmediatamente para feedback visual
    setMessages(prev => [...prev, data]);
    
    // Emitir mensaje al servidor
    socketRef.current.emit('chat message', data);
    
    // También enviar mediante API REST
    fetch(`${API_URL}/api/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(res => console.log("Mensaje guardado:", res))
    .catch(err => console.error("Error al guardar el mensaje:", err));
    
    setMessage('');
  };
  
  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h2>Chat de Prueba</h2>
          <span className={`badge ${connected ? 'bg-success' : 'bg-danger'}`}>
            {connected ? 'Conectado' : 'Desconectado'}
          </span>
        </div>
        <div className="card-body">
          <div className="mb-3">
            <label htmlFor="sender" className="form-label">Nombre del emisor:</label>
            <input 
              type="text" 
              id="sender" 
              className="form-control" 
              placeholder="Ej: miguel"
              value={sender}
              onChange={(e) => setSender(e.target.value)}
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="receiver" className="form-label">Nombre del receptor:</label>
            <input 
              type="text" 
              id="receiver" 
              className="form-control" 
              placeholder="Ej: jose"
              value={receiver}
              onChange={(e) => setReceiver(e.target.value)}
            />
          </div>
          
          <form onSubmit={handleSendMessage} className="d-flex mb-3">
            <input
              type="text"
              className="form-control me-2"
              placeholder="Escribe tu mensaje"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">Enviar</button>
          </form>
          
          <div className="mt-4">
            <h4>Mensajes:</h4>
            {messages.length === 0 ? (
              <p className="text-muted">No hay mensajes aún.</p>
            ) : (
              <ul className="list-group">
                {messages.map((msg, index) => (
                  <li key={index} className="list-group-item">
                    <strong>{msg.sender} → {msg.receiver}:</strong> {msg.message}
                    <small className="text-muted d-block">
                      {new Date(msg.timestamp || Date.now()).toLocaleTimeString()}
                    </small>
                  </li>
                ))}
              </ul>
            )}
          </div>
          
          <div className="mt-4">
            <button 
              className="btn btn-secondary"
              onClick={() => console.log('Estado actual de mensajes:', messages)}
            >
              Depurar mensajes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatTest; 